<template>
  <div>
    <div class="question_con" v-if="!isMobile">
      <div class="question_item" v-for="(d, index) in data" :key="index">
        <div class="question">
          <span>Q</span>
          <p>{{ d.question }}</p>
        </div>
        <div class="answer">
          <span>A</span>
          <p>{{ d.answer }}</p>
        </div>
      </div>
    </div>
    <div class="app_question_con" v-else>
      <div class="question_item" v-for="(d, index) in data" :key="index">
        <div class="question">
          <span>Q</span>
          <p>{{ d.question }}</p>
        </div>
        <div class="answer">
          <span>A</span>
          <p>{{ d.answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from '@/mixins/responsiveMixin';
export default {
  name: 'Question',
  mixins: [responsiveMixin],

  data() {
    return {
      data: [
        {
          question: '今年的青年竞演报名提交方式是否有变化？',
          answer:
            '本届青年竞演报名以及参赛资料投递均采用线上方式完成。请仔细阅读小镇奖报名细则十一、报名程序的第二部分，线上提交参赛材料。',
        },
        {
          question: '是否需要提供剧本？',
          answer: '是否需要提供剧本？',
        },
        {
          question: '2024年青年竞演报名截止时间跟往年一样吗？',
          answer: '本届青年竞演报名截止时间为8月20日。',
        },
        {
          question: '今年的青年竞演报名提交方式是否有变化？',
          answer:
            '本届青年竞演报名以及参赛资料投递均采用线上方式完成。请仔细阅读小镇奖报名细则十一、报名程序的第二部分，线上提交参赛材料。',
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.question_con {
  background: #fff;
  .question_item {
    border-bottom: solid 1px #6b6d7a;
    padding: 1.5rem 0;
    .question {
      color: #6b6d7a;
      display: flex;
      align-items: flex-start;
      margin-bottom: 0.5rem;
      span {
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        line-height: 1.25rem;
        text-align: center;
        background: #6b6d7a;
        color: #fff;
        font-size: 1.125rem;
        margin-right: 0.5rem;
        margin-top: 0.75rem;
      }
      p {
        flex: 1;
        line-height: 2.5rem;
      }
    }
    .answer {
      display: flex;
      color: #6a1211;
      align-items: flex-start;
      margin-bottom: 0.5rem;
      span {
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        line-height: 1.25rem;
        text-align: center;
        background: #6a1211;
        color: #fff;
        font-size: 1.125rem;
        margin-right: 0.5rem;
        margin-top: 0.75rem;
      }
      p {
        flex: 1;
        line-height: 2.5rem;
      }
    }
  }
}
.app_question_con {
  background: #fff;
  .question_item {
    border-bottom: solid 1px #6b6d7a;
    padding: 0.6667rem 0;
    .question {
      color: #6b6d7a;
      display: flex;
      align-items: flex-start;
      margin-bottom: 0.4167rem;
      span {
        display: inline-block;
        width: 1.1667rem;
        height: 1.1667rem;
        line-height: 1.1667rem;
        text-align: center;
        background: #6b6d7a;
        color: #fff;
        font-size: 1;
        margin-right: 0.5rem;
      }
      p {
        flex: 1;
      }
    }
    .answer {
      display: flex;
      align-items: flex-start;
      color: #6a1211;
      margin-bottom: 0.4167rem;
      span {
        display: inline-block;
        width: 1.1667rem;
        height: 1.1667rem;
        line-height: 1.1667rem;
        text-align: center;
        background: #6a1211;
        color: #fff;
        font-size: 1rem;
        margin-right: 0.5rem;
      }
      p {
        flex: 1;
      }
    }
  }
}
</style>
